<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                </el-form-item>
                <!-- <el-form-item label="选项">
                    <el-select v-model="form.checkPlatform" placeholder="选项" @change="changeOptions">
                        <el-option label="平台" :value="true"></el-option>
                        <el-option label="学校" :value="false"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="训练模块">
                    <el-select v-model="form.trainModuleId" clearable placeholder="训练模块"  :disabled="module.id>0">
                        <el-option
                            v-for="item in trainModule"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-radio-group v-model="form.type ">
                    <el-radio-button label="1">题目分析</el-radio-button>
                    <el-radio-button label="2">挑战人分析</el-radio-button>
                </el-radio-group>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                v-if="form.type == 1"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="trainQuestionTitle"
                    label="题目" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="avgScore"
                    label="平均分" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="correctRateString"
                    label="正确率">
                </el-table-column>
            </el-table>
            <el-table
                :data="tableData"
                v-if="form.type == 2"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="studentName"
                    label="学生" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="score"
                    label="总分" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="questionCount"
                    label="答题量" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="correctRateString"
                    label="正确率">
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>

    import {mapMutations} from 'vuex';


    export default {
        components: {

        },
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    checkPlatform: false,
                    enable: true,
                    trainModuleId: '',
                    type:1,
                },
                module:{...this.attr.item},
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                trainModule:{},
            }

        },
        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            //changeType(type) {
            //    this.form.type = type;
            //    this.loadData();
            //},
            loadData() {
                this.tableData = [];
                this.form.trainModuleId = this.module.id;
                if(this.form.type == 1){
                    this.$ajaxPost("/trainAnswer/avgScoreAndCrrectRateStatistics", {
                        form: this.form,
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                    })
                }else{
                    this.$ajaxPost("/trainAnswer/listStatistics", {
                        form: this.form,
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                    })
                }

            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            changeOptions() {
                this.loadTrainModule();
            },
            loadTrainModule() {
                this.$ajaxGet("/trainModule/listBySelectedConfig/1", (data) => {//listBySchoolType/"+this.form.checkPlatform
                    this.trainModule = data.result;
                })
            },
        },

        created() {
            this.loadData();
            this.loadTrainModule();
        }

    }
</script>
